module.exports = __webpack_public_path__ + "img/callcenter.362bcf6.png";


//////////////////
// WEBPACK FOOTER
// ./static/callcenter.png
// module id = 4gWa
// module chunks = 1 3